import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {RouterModule} from '@angular/router';

import { NavbarComponent } from './navbar/navbar.component';
import { FooterCommonComponent } from './footer-common/footer-common.component';
import { ContactSectionComponent } from './contact-section/contact-section.component';


@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    RouterModule
  ],
  declarations: [
    NavbarComponent,
    FooterCommonComponent,
    ContactSectionComponent,
  ],
  providers: [], 
  exports:[NavbarComponent, FooterCommonComponent, ContactSectionComponent]
})
export class ComponentsModule {}
